import moment from "moment";

export const DateFormat = {
    DDMMYYYY: 'DD/MM/YYYY',
    MMDDYYYY: 'MM/DD/YYYY',
    YYYYMMDD: 'YYYY-MM-DD',
    // Add more date formats as needed
  };

function getCurrYearMonthDate() {
    const today = new Date();
    return {
        today: today,
        yy: today.getFullYear(),
        mm: today.getMonth(),
        dd: today.getDate()
    }
}

// set the date 10 years after today
export function tenYearsAfter() {
    const { today, mm, dd } = getCurrYearMonthDate();
    const yy = today.getFullYear() + 10;
    // month starts with 0
    return new Date(yy, mm, dd);
}

// set the date 10 years after today
export function tenYearsBefore() {
    const { today, mm, dd } = getCurrYearMonthDate();
    const yy = today.getFullYear() - 10;
    // month starts with 0
    return new Date(yy, mm, dd);
}

// the year is at least 17 years ago
export function mustBe17() {
    const { today, mm, dd } = getCurrYearMonthDate();
    const yy = today.getFullYear() - 17;
    // month starts with 0
    return new Date(yy, mm, dd);
}

// set the date 120 years ago
export function minDate() {
    const { today, mm, dd } = getCurrYearMonthDate();
    const yy = today.getFullYear() - 120;
    return new Date(yy, mm, dd);
}

export function yesterday() {
}

// ship default react calendar date to the one that is used in TWS
// Thu Feb 06 2020 00:00:00 GMT+0800 (China Standard Time)
// to 05/02/2003 (day/mon/year)
export function maskDate(date) {
    const maskedDate = moment(date).format(DateFormat.DDMMYYYY);
    // Invalid date
    return date && maskedDate !== 'Invalid date' ? maskedDate : date;
}

// 23/04/2020
export function unMaskDate(date) {
    let updatdDate = date;
    if (date) {
        if (date.toString() === 'Invalid Date') {
            updatdDate = '';
        } else {
            // the order is day, month, year
            const dates = date.split('/');
            // recieve date is year, month, day
            // also remember, the month starts with 0 rather than 1
            updatdDate = dates.length === 3 ? new Date(dates[2], dates[1] - 1, dates[0]) : new Date();
        }
    }
    return updatdDate;
}

function pad(number) {
    if (parseInt(number) < 10) {
        return '0' + number;
    }
    return number;
}

export function maskToTwsDate(date) {
    // 2020-04-16T00:00:00Z
    // 2020-04-29T16:00:00.000Z
    let updatedDate = date;
    if (typeof (date) === 'string') {
        updatedDate = unMaskDate(date);
    }
    if (typeof (updatedDate) === 'string') {
        return date;
    } else {
        return updatedDate.getUTCFullYear() +
            '-' + pad(updatedDate.getMonth() + 1) +
            '-' + pad(updatedDate.getDate()) +
            'T' + pad(updatedDate.getHours()) +
            ':' + pad(updatedDate.getMinutes()) +
            ':' + pad(updatedDate.getSeconds()) +
            '.' + (updatedDate.getMilliseconds() / 1000).toFixed(3).slice(2, 4) +
            'Z';
    }
}

export function maskToDurationString(isAm, duration) {
    const { hours, minutes } = duration;
    let actualHour = hours;
    if (!isAm) {
        actualHour = hours - 12;
    }
    if (actualHour === 0) {
        actualHour += 12;
    }
    return pad(actualHour) + ':' + pad(minutes);
}

export function getDuration(time) {
    const duration = moment.duration(time);
    const { _data } = duration;
    const { hours } = _data;
    const isAm = hours < 12;
    let timeExisted = time ? true : false;
    return {
        duration: _data,
        timeString: maskToDurationString(isAm, _data),
        isAm: isAm,
        timeExisted: timeExisted
    }
}

// PT21H00M00S
export function maskDuration(duration, isAm) {
    const { hours, minutes } = duration;
    let updatedHours = hours;
    if ((isAm || isAm === '') && hours === 12) {
        updatedHours = 0;
    }
    return 'PT' + pad(updatedHours) + 'H' + pad(minutes) + 'M00S';
}

export function parseTime(time, service) {
    const parsedTime = getDuration(time);
    const { duration, timeString, isAm, timeExisted } = parsedTime;
    if (timeExisted) {
        service.value = timeString;
        service.duration = duration;
        service.isAm = isAm;
    }
}
